require('./file-inputs');
require('./fred-configurator');
require('./image-hover-zoom');
require('./maier-tabs');
require('./scroll-to-top-button');